var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "diaper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.844,
    height: 35,
    viewBox: "0 0 36.844 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_6588580_and_baby_diaper_nappies_toys_icon",
    "data-name": "6588580_and_baby_diaper_nappies_toys_icon",
    d: "M29.633,17.125a1.315,1.315,0,0,1-1.316-1.458V11.292a1.315,1.315,0,0,1,1.316-1.458h9.079A6.826,6.826,0,0,0,32.265,4H8.579A6.826,6.826,0,0,0,2.132,9.833h9.079a1.315,1.315,0,0,1,1.316,1.458v4.375a1.315,1.315,0,0,1-1.316,1.458H2v1.458c0,9.479,5.79,17.354,13.685,19.687.132,0,.263.146.395.146A14.267,14.267,0,0,0,20.422,39a20.368,20.368,0,0,0,4.284-.583c.132,0,.709-.288.841-.288,7.9-2.333,13.3-9.92,13.3-19.4V17.271H29.633Zm-24.606,5.1A20.045,20.045,0,0,1,14.5,34.771,16.935,16.935,0,0,1,5.026,22.229ZM26.475,34.771a20.045,20.045,0,0,1,9.474-12.542A17.568,17.568,0,0,1,26.475,34.771Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaper);
export default __webpack_public_path__ + "static/media/diaper.d2c16ed339bd883de4d0045f8d301cbd.svg";
export { ForwardRef as ReactComponent };